// Shared BridgeChat props for the Front Desk (Ask AI on the external layer).
export const ASKAI_PROPS = {
  base: '/askai',
  answersFirst: true,   // Company Answers before the AI (Pat, Oct 5 2026)
  typeahead: true,      // matching questions under the box as you type (Ryan, Oct 21 2026)
  title: 'Ask AI',
  subtitle: "Ask about your jobs — schedule, materials, what's left to do",
  placeholder: 'Ask about your jobs…',
  agentLabel: 'Titan AI',
  emptyTitle: 'Ask the Front Desk anything.',
  emptyBody: "What you need, where to be, what's left to do — it can see across your jobs.",
  accent: '#e87722',
  icon: '⚡',
  iconBg: '#e87722',
  waitingText: 'Front Desk is looking…',
  pill: { text: 'Live', bg: '#dcfce7', color: '#15803d', dot: '#16a34a' },
  suggestions: [
    'What do I need for my jobs tomorrow?',
    'Where are my job sites?',
    'Who else is on my crew?',
    "What's left to do on my jobs?",
    'What materials do I need?',
  ],
};
